/** Alert banner controller **/
import { sessionCookieHelper } from './cookieModule.js'

const alertBannerController = {
    init: function() {
        return () => {
            let self = this
            let alertBanner = document.querySelector('#alert-banner')
            if (alertBanner){
                self.correctPadding()
                window.addEventListener('resize', function(event) {
                    self.correctPadding()
                }, true)
                var banner_cookie = sessionCookieHelper.get_cookie('bannerShow')

                if (!banner_cookie){
                    sessionCookieHelper.set_cookie( 'bannerShow', 'true' )
                    self.show_banner();
                }
                if (banner_cookie == 'true'){
                    self.show_banner()
                }
                if (banner_cookie == 'no') {
                    self.close_banner()
                }

                document.addEventListener('click', function (event) {
                    if(!event.target.matches('#banner_dismiss span')){
                        return
                    }

                    self.close_banner()

                }, false)
            }
        }
    },
    correctPadding: function(){
        let alertBanner = document.querySelector('#alert-banner')
        let banner_height = alertBanner.offsetHeight
        let mainContent = document.querySelector('#main')
        let padding_top = banner_height + 'px'
        mainContent.style.paddingTop = padding_top
    },
	close_banner: function() {
        let alert_banner = document.querySelector('#alert-banner')
        alert_banner.style.display = 'none'
		sessionCookieHelper.set_cookie( 'bannerShow', 'no' );
        let mainContent = document.querySelector('#main')
        mainContent.style.paddingTop = '0px'
	},
	show_banner: function() {
        let alert_banner = document.querySelector('#alert-banner')
        alert_banner.style.display = 'block'
	}
}

let alertBanner = alertBannerController.init()

alertBanner()